import { createHashHistory, createBrowserHistory } from 'history';
export const hashHistory = createHashHistory();
export const browserHistory = createBrowserHistory();